import { useAppSelector } from "../../../../lib/redux/hooks";

export function ComparazioneZootecnia() {
    const notificationState = useAppSelector(state => state.notification)
    const selectedNot = notificationState.notificationIdToUpdate;
    const comparisonState = useAppSelector(state => state.NotComparison)
    return (

        <div>
            {
                comparisonState.GetComparisonResponse && (
                    <>
                        <div className="displayFlex gap-3 mt-6">
                            <div style={{ flex: '0.5' }}>
                                <div className="fieldset2-header" >
                                    <span className='title'>Specie presenti nella notifica {comparisonState.GetComparisonResponse.currentNotification}</span>

                                </div>
                                <div className='fieldset2-content'>
                                    <div>
                                        <table id="list-table" className="w-[100%]">
                                            <thead className="h-[40px] uppercase">
                                                <tr>
                                                    <th>Specie</th>
                                                    <th>Consistenza</th>
                                                    <th>Metodo</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    comparisonState.GetComparisonResponse.actualLivestockComparisons.map((actzoot) =>
                                                        <tr>
                                                            <td>
                                                                {actzoot.animalSpecies}
                                                            </td>
                                                            <td>
                                                                {actzoot.consistency}
                                                            </td>
                                                            <td>
                                                                {actzoot.method}
                                                            </td>
                                                        </tr>
                                                    )
                                                }
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            <div style={{ flex: '0.5' }}>
                                <div className="fieldset2-header" >
                                    <span className='title'>Specie presenti nella notifica {comparisonState.GetComparisonResponse.previousNotification}</span>

                                </div>
                                <div className='fieldset2-content'>
                                    <div>
                                        <table id="list-table" className="w-[100%]">
                                            <thead className="h-[40px] uppercase">
                                                <tr>
                                                    <th>Specie</th>
                                                    <th>Consistenza</th>
                                                    <th>Metodo</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    comparisonState.GetComparisonResponse.previousLivestockComparisons.map((previous) =>
                                                        <tr>
                                                            <td>
                                                                {previous.animalSpecies}
                                                            </td>
                                                            <td>
                                                                {previous.consistency}
                                                            </td>
                                                            <td>
                                                                {previous.method}
                                                            </td>
                                                        </tr>
                                                    )
                                                }

                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
                )
            }

        </div>
    )
}